var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.dashboard,
      expression: "loading.dashboard"
    }],
    staticClass: "filters"
  }, [_c('el-form', {
    attrs: {
      "inline": "",
      "size": "small"
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "unlink-panels": "",
      "clearable": "",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "format": _vm.dateRangeFormat,
      "picker-options": _vm.datePickerOptions
    },
    model: {
      value: _vm.datesRange,
      callback: function ($$v) {
        _vm.datesRange = $$v;
      },
      expression: "datesRange"
    }
  })], 1)], 1)], 1), _c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.sales,
      expression: "loading.sales"
    }],
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "title": "Sales"
    }
  }, [_c('Table', {
    attrs: {
      "items": _vm.cleanedResults,
      "columns": _vm.columns,
      "actions": _vm.actions,
      "links": _vm.links
    }
  }), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "current-page": _vm.sales.page + 1,
      "total": _vm.sales.total
    },
    on: {
      "current-change": _vm.fetchData
    }
  })], 1)], 1), _c('SalesDialog', {
    attrs: {
      "item": _vm.item,
      "isOpen": _vm.showEditDialog,
      "onClose": function () {
        return _vm.showEditDialog = false;
      }
    },
    on: {
      "saved": _vm.fetchData
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }